/**
 * @generated SignedSource<<8d4349b1cac0df936215bba653a60c6f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BankTransactionGroup = "CUSTOMER_PAYMENTS" | "FINANCING" | "OTHER" | "SALARIES" | "SUPPLIERS" | "TAX_OFFICE" | "TRANSFER" | "%future added value";
export type ForecastCategory = "DEPRECIATION" | "FINANCING" | "INCOME_TAXES" | "OTHER" | "OTHER_OPERATING_INCOME" | "PERSONNEL" | "REVENUE" | "SUPPLIERS" | "%future added value";
export type PlannedItemEffect = "LIQUIDITY_ONLY" | "RESULT_AND_LIQUIDITY" | "RESULT_ONLY" | "%future added value";
export type PlannedItemRhythm = "MONTHLY" | "ONE_TIME" | "QUARTERLY" | "YEARLY" | "%future added value";
export type VatRate = "NONE" | "REDUCED" | "STANDARD" | "%future added value";
export type ChangePlannedItemInput = {
  definition: PlannedItemDefinitionInput;
  id: string;
};
export type PlannedItemDefinitionInput = {
  category: ForecastCategory;
  dayOfMonth: number;
  effect: PlannedItemEffect;
  endMonth?: string | null | undefined;
  liquidityGroup?: BankTransactionGroup | null | undefined;
  name: string;
  netAmount: number;
  rhythm: PlannedItemRhythm;
  startMonth: string;
  vatRate: VatRate;
};
export type EditPlannedItemDialogChangeMutation$variables = {
  input: ChangePlannedItemInput;
};
export type EditPlannedItemDialogChangeMutation$data = {
  readonly changePlannedItem: {
    readonly changedAt: any | null | undefined;
    readonly changedBy: string | null | undefined;
    readonly definition: {
      readonly category: ForecastCategory;
      readonly dayOfMonth: number;
      readonly effect: PlannedItemEffect;
      readonly endMonth: string | null | undefined;
      readonly liquidityGroup: BankTransactionGroup | null | undefined;
      readonly name: string;
      readonly netAmount: number;
      readonly rhythm: PlannedItemRhythm;
      readonly startMonth: string;
      readonly vatRate: VatRate;
    };
    readonly id: string;
    readonly nextDueDate: any | null | undefined;
  };
};
export type EditPlannedItemDialogChangeMutation = {
  response: EditPlannedItemDialogChangeMutation$data;
  variables: EditPlannedItemDialogChangeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PlannedItem",
    "kind": "LinkedField",
    "name": "changePlannedItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "nextDueDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "changedBy",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "changedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PlannedItemDefinition",
        "kind": "LinkedField",
        "name": "definition",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "category",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "netAmount",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "vatRate",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "rhythm",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "startMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dayOfMonth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "effect",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "liquidityGroup",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPlannedItemDialogChangeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditPlannedItemDialogChangeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "22605b9c605aa288ea190cfe87a89178",
    "id": null,
    "metadata": {},
    "name": "EditPlannedItemDialogChangeMutation",
    "operationKind": "mutation",
    "text": "mutation EditPlannedItemDialogChangeMutation(\n  $input: ChangePlannedItemInput!\n) {\n  changePlannedItem(input: $input) {\n    id\n    nextDueDate\n    changedBy\n    changedAt\n    definition {\n      name\n      category\n      netAmount\n      vatRate\n      rhythm\n      startMonth\n      endMonth\n      dayOfMonth\n      effect\n      liquidityGroup\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4fcb68b12041adff352018bd3fd96404";

export default node;
